import {BaseTile, TileType} from './BaseTile';

export class SteelTile extends BaseTile {
    type = TileType.steel;
    sprite = '/assets/siccinct/tiles/steel.png';

    selectable = true;
}